import { FormControl, FormField, FormItem } from '@/components/ui/form'
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import { useMemo } from 'react'

export default function FormPagination({ control, watch }) {
  const [pageLimit, total, currentPage] = watch([
    'pageLimit',
    'total',
    'pageNum',
  ])

  const allPagesNum = useMemo(() => {
    if (!pageLimit || !total) return 1
    return Math.ceil(total / pageLimit)
  }, [pageLimit, total])

  let isPageNumberOutOfRange

  const pageNumbers = (field) => {
    return [...new Array(allPagesNum)].map((_, index) => {
      const pageNumber = index + 1
      const isPageNumberFirst = pageNumber === 1
      const isPageNumberLast = pageNumber === allPagesNum
      const isCurrentPageWithinTwoPageNumbers =
        Math.abs(pageNumber - currentPage) <= 1

      if (
        isPageNumberFirst ||
        isPageNumberLast ||
        isCurrentPageWithinTwoPageNumbers
      ) {
        isPageNumberOutOfRange = false
        return (
          <PaginationItem key={pageNumber}>
            <PaginationLink
              onClick={() => field.onChange(pageNumber)}
              isActive={pageNumber === currentPage}
            >
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        )
      }

      if (!isPageNumberOutOfRange) {
        isPageNumberOutOfRange = true
        return <PaginationEllipsis key={pageNumber} className="muted" />
      }

      return null
    })
  }

  return (
    <FormField
      control={control}
      name="pageNum"
      render={({ field }) => (
        <FormItem>
          <FormControl>
            <Pagination className="md:justify-end! mt-4">
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious
                    onClick={() => field.onChange(field.value - 1)}
                    disabled={field.value === 1}
                  />
                </PaginationItem>

                {pageNumbers(field)}

                <PaginationItem>
                  <PaginationNext
                    onClick={() => field.onChange(field.value + 1)}
                    disabled={field.value === allPagesNum}
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </FormControl>
        </FormItem>
      )}
    />
  )
}
